import React, { useState } from "react";
import { Link } from "react-router-dom";
import { BackArrowIcon2, Back_img, Brandicon, New_ScrollX2025, Settings, scrollxLogo, scrollx_icon } from "../assets/icons";
import Setting from "../Pages/Setting/Setting";

export default function Navbar_back_btn() {
  const [isSettingOpen, setIsSettingOpen] = useState(false);

  return (
    <div className="w-full Pro_navbarDash  flex flex-wrap items-center justify-between text-slate-200 focus:text-sly-700 drop-shadow-2xl px-[19px]">
    
       <div className="flex items-center w-[15%]">
                <button className="flex items-center" >
                <Link className="flex items-center" to="/dashboard">
                  <img className=" w-[11px] cursor-pointer" src={BackArrowIcon2} alt=""/>
                  </Link>
                </button>
              
                <div className="flex h-full pt-[1px] items-center pl-[7%]">
                  <img className="w-[35px] " src={New_ScrollX2025} />
                  <span className="ml-[10px] Syne700 text-xl  tracking-wide ">ScrollX.io</span> 
                </div>
                </div>

      <div className="flex justify-center items-center w-[15%]">
     <h1 className=" text-[15px] manrope-600">Account Settings</h1>
      </div>

      <div className="flex items-center w-[15%] ">
        {/* <img src={Settings} style={{ width: "30px" }} /> */}
        <button onClick={() => setIsSettingOpen(true)}>
          {/* <img src={Settings} style={{ width: "30px" }} /> */}
        </button>
        <div className="absolute right-[15%] z-40 ">
          <Setting
            isSettingOpen={isSettingOpen}
            setIsSettingOpen={setIsSettingOpen}
          />
        </div>
      </div>
    </div>
  );
}
